import { css } from '@microsoft/fast-element';
export const flyoutAnimationTime = 225;
export const foundationFlyoutStyles = css `
  /* Host */
  :host {
    display: inline-block;
    height: 100vh;
    position: absolute;
    width: 100vw;
  }

  :host([closed]) {
    display: none;
  }

  div.container {
    height: 100%;
    width: 100%;
  }

  /* flyout */
  div.flyout {
    background-color: white;
    color: black;
    height: 100%;
    position: absolute;
    /* stylelint-disable-next-line function-name-case */
    transition: transform ${flyoutAnimationTime.toString()}ms ease-in;
    width: 20%;
    z-index: 2001;
  }

  :host([position='left']) div.flyout {
    left: 0;
    transform: translateX(0%);
  }

  :host([position='right']) div.flyout {
    right: 0;
    transform: translateX(0%);
  }

  :host([visuallyhidden][position='left']) div.flyout {
    left: 0;
    transform: translateX(-100%);
  }

  :host([visuallyhidden][position='right']) div.flyout {
    right: 0;
    transform: translateX(100%);
  }

  div.header {
    align-items: center;
    display: flex;
    padding: calc(var(--design-unit) * 3px) calc(var(--design-unit) * 2px);
  }

  div.title {
    flex-grow: 1;
  }

  div.footer {
    bottom: 0;
    position: absolute;
    width: 100%;
  }

  /* Background */
  div.background {
    background-color: black;
    height: 100%;
    opacity: 50%;
    position: absolute;
    /* stylelint-disable-next-line function-name-case */
    transition: opacity ${flyoutAnimationTime.toString()}ms linear;
    width: 100%;
    z-index: 2000;
  }

  :host([visuallyhidden]) div.background {
    opacity: 0%;
  }
`;
